import Accordion from "client/common/components/interactive/Accordion";
import { useFeaturedSupportItemsQuery } from "client/support/hooks";
import LoadingContainer from "client/common/components/loading/LoadingContainer";
import { catchallItems } from "client/support/constants";
import Markdown from "client/common/components/content/Markdown";

import styles from "../styles/BrowseSupport.module.less";

const BrowseSupportContent = () => {
  const { data: items, isLoading, error } = useFeaturedSupportItemsQuery();

  if (isLoading) {
    return <LoadingContainer />;
  }

  const itemsToShow = !error && items?.length ? items : catchallItems;
  const itemContent = itemsToShow.map((item) => ({
    key: item.id,
    content: <Markdown markdown={item.body} hasHtml={true} />,
    label: item.title,
  }));

  return (
    <Accordion.Single
      classNames={{ label: styles.label, content: styles.itemContent }}
      items={itemContent}
    />
  );
};

const BrowseSupport = () => {
  return (
    <div className={styles.faqs}>
      <div className={styles.info}>
        <div className={styles.heading}>
          <h4 className={styles.header}>
            Frequently asked questions about <span className={styles.name}>our online store</span>
          </h4>
        </div>
      </div>
      <div className={styles.content}>
        <BrowseSupportContent />
      </div>
    </div>
  );
};

export default BrowseSupport;
